'use strict';

/**
 * Module definition file
 *
 * All services, controllers, and directives are registered with angular here
 */

var list = angular.module('saturn.list', []);

var listDirective = require('./ListDirective');
var ListController = require('./ListController');

list.controller('ListController', [
  '$scope',
  ListController
]);

list.directive('sbList', [
  listDirective
]);

// ## Template Module
require('./templates.js');



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/list/src/index.js